export function toInt(value?: string) {
  return value ? parseInt(value, 10) : 0;
}
